import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    stepBallNormal: {
      '&> span':{
        '&> svg':{
          position:"relative",
          zIndex: 2
        }
      },
    },
    stepBall : {
      '&> span':{
        '&> svg':{
          color:"#286796",
          position:"relative",
          zIndex: 2
        }
      },
    },
    outsideStep: {
      justifyContent: "space-between",
      padding:0,
      paddingTop: "3em"
    },
    insideStep: {
      flex: "none",
      padding: 0,
      '&> span':{
        alignItems: 'start !important'
      },
     
    },
    insideStepMiddle: {
      flex: "none",
      padding: 0,
    },
    insideStepLeft: {
      flex: "none",
      padding: 0,
      '&> span':{
        alignItems: 'end !important'
      },
     
    },
    stepLabel : {
        '&> span':{
          '&> span':{
            fontSize: '14px',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 'bold',
            lineHeight: '16px',
            textAlign: 'start !important'
          }
        },
      },
      stepLabelAlignCenter : {
        '&> span':{
          '&> span':{
            fontSize: '14px',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 'bold',
            lineHeight: '16px',
            textAlign: 'center'
          }
        },
      },
      stepLabelAlignRight : {
        '&> span':{
          '&> span':{
            fontSize: '14px',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 'bold',
            lineHeight: '16px',
            textAlign: 'end !important'
          }
        },
      },
    alignStart : {
      alignItems: "start !important"
    },
    stepperNew: {
      display:"flex",
      flexDirection:"row",
      alignItems: "center",
    },
    stepperNewText: {
      display:"flex",
      flexDirection:"row",
      justifyContent:"space-between"
    },
    stepperNewIcon: {
      display:"flex",
      flexDirection:"row",
      justifyContent:"space-between"
    },
  }))

export default useStyles
